import React, { Component } from "react";
import "./IdeaCard.css";
import { withFirebase } from "../Firebase";
import { withRouter } from "react-router-dom";
import { AddComment } from "./Comments"
import { IdeaCardHeader } from "./IdeaCardHeader";
import PictureModal from "./PictureModal"
import Modal from "react-responsive-modal";
import DeleteIdeaOrPollModal from "./IdeaSection/DeleteIdeaOrPollModal";
import { SingleComment } from "./SingleComment/SingleComment";
import EditIdea from "./IdeaSection/EditIdea";

const cardHighlighted = {
  boxShadow: "0 30px 100px -8px rgba(0,27,83,0.2)",
}

class IdeaCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined, highlighted: false,
      current_uid: '', comments: props.idea.comments,
      idea: props.idea, newComments: [],
      showPicture: false, picture: "",
      deleteOpen: false,
      deleteConfirmed: false,
      openEdit: false,
    };
  }

  componentDidMount() {

    let uid;
    let idea = this.state.idea

    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid })
      this.props.firebase.db
        .collection("users")
        .doc(idea.creator)
        .get()
        .then(doc => {
          this.setState({
            user: doc.data(),
            creatorId: doc.id
          });
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.comments !== this.state.comments) {
      this.setState({ comments: nextProps.comments })
    }
    if (nextProps.idea.creator !== this.state.creatorId) {
      this.props.firebase.db
        .collection("users")
        .doc(nextProps.idea.creator)
        .get()
        .then(doc => {
          this.setState({
            user: doc.data(),
            creatorId: doc.id
          });
        });
    }
  }

  commentsDoor = () => {
    this.setState({
      highlighted: !this.state.highlighted
    })
  }

  addToComments = (comments) => {
    const { idea } = this.props
    this.props.updateComments(idea, comments)
  }

  closePicture = () => {
    this.setState({
      showPicture: false
    })
  }

  openPicture = (url) => {
    this.setState({
      showPicture: true,
      picture: url
    })
  }

  openDelete = () => {
    this.setState({
      deleteOpen: true
    })
  }

  closeDelete = (status) => {
    this.setState({
      deleteOpen: false
    })
    if (status === 'accept') {
      this.setState({ deleteConfirmed: true })
    }
  }

  openDeleteComment = () => {
    this.setState({
      deleteOpenComment: true
    })
  }

  closeDeleteComment = (status) => {
    this.setState({
      deleteOpenComment: false
    })
    if (status === 'accept') {
      this.setState({ deleteConfirmed: true })
    }
  }

  onDeleteExited = () => {
    const { deleteConfirmed } = this.state
    if (deleteConfirmed) {
      window.location.reload();
    }
  }

  updateIdeaComments = async (comment, index) => {
    let { comments, idea } = this.state
    comments[index] = comment
    await this.props.firebase.db.collection('capsules').doc(this.props.idCapsule).collection('ideas').doc(idea.id).update({
      comments
    })
  }

  deleteIdeaComment = async (index) => {
    let { comments, idea } = this.state
    comments.splice(index, 1)
    this.setState({ comments })
    await this.props.firebase.db.collection('capsules').doc(this.props.idCapsule).collection('ideas').doc(idea.id).update({
      comments
    })
  }

  openEdit = () => {
    this.setState({
      openEdit: true
    })
  }

  closeEdit = () => {
    this.setState({
      openEdit: false
    })
  }

  render() {
    const {
      highlighted,
      user,
      picture,
      comments,
      current_uid,
    } = this.state;
    const { idea } = this.props
    let commentsCard = []

    if (comments) {
      commentsCard = comments
    }
    else if (idea) {
      commentsCard = idea.comments
    }

    if (!commentsCard) {
      commentsCard = []
    }

    return (
      <>
        <div className="idea-card" style={highlighted ? cardHighlighted : {}}>
          {user && <IdeaCardHeader openEdit={this.openEdit} openDelete={this.openDelete} openPicture={this.openPicture} currentUserId={current_uid} idcapsule={this.props.idCapsule} idea={this.props.idea} user={user} index={this.props.index} canaddlike={this.props.canAddLike} />}
          <h1 className="text-center title-comentaire cursor-pointer" hidden={!this.props.canAddComment} onClick={this.commentsDoor} >Commentaires ({commentsCard.length})</h1>
          <div hidden={!highlighted}>
            <div className="scroll-com p-3">
              {commentsCard.map((comment, index) =>
                <SingleComment
                  key={comment.comment + index}
                  comment={comment}
                  index={index}
                  updateIdeaComments={this.updateIdeaComments}
                  deleteIdeaComment={this.deleteIdeaComment}
                  currentUserId={current_uid}
                  idea={idea} />
              )}
            </div>
            <AddComment
              idCard={this.props.idCard}
              idCapsule={this.props.idCapsule}
              currentComments={commentsCard}
              addComments={this.addToComments}
            />
          </div>
        </div>
        <Modal
          open={this.state.showPicture}
          onClose={this.closePicture}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <PictureModal
            onClose={this.closePicture}
            myPicture={picture}
          />
        </Modal>
        <Modal
          open={this.state.deleteOpen}
          onClose={this.closeDelete}
          center
          showCloseIcon={true}
          styles={styles_delete}
          onExited={this.onDeleteExited}
        >
          <DeleteIdeaOrPollModal
            onClose={this.closeDelete}
            openDelete={this.openDelete}
            capsuleId={this.props.idCapsule}
            elementId={idea.id}
            elementType={'idea'} />

        </Modal>
        <Modal
          open={this.state.openEdit}
          onClose={this.closeEdit}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <EditIdea
            onClose={this.closeEdit}
            idea={idea}
            capsuleId={this.props.idCapsule} />
        </Modal>
      </>
    );
  }
}

const styles_desktop = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "601px",
    maxWidth: "395px",
    top: "10%",
    padding: "0px",
  }
};

const styles_mobile = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    boxShadow: 'none',
    minHeight: "100%",
    width: "100%",
    padding: "0px",
  }
};

const styles_delete = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "355px",
    maxWidth: "321px",
    top: "10%",
    padding: "0px",
  }
};


const IdeaCardB = withRouter(withFirebase(IdeaCard));

export default IdeaCardB;
export { IdeaCard };
